var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThreedotver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 14,
    viewBox: "0 0 4 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 2.65208C2.16421 2.65208 2.5 2.33122 2.5 1.93542C2.5 1.53961 2.16421 1.21875 1.75 1.21875C1.33579 1.21875 1 1.53961 1 1.93542C1 2.33122 1.33579 2.65208 1.75 2.65208Z",
    stroke: "#ABA7AF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 7.90599C2.16421 7.90599 2.5 7.58513 2.5 7.18932C2.5 6.79352 2.16421 6.47266 1.75 6.47266C1.33579 6.47266 1 6.79352 1 7.18932C1 7.58513 1.33579 7.90599 1.75 7.90599Z",
    stroke: "#ABA7AF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 13.1638C2.16421 13.1638 2.5 12.8429 2.5 12.4471C2.5 12.0513 2.16421 11.7305 1.75 11.7305C1.33579 11.7305 1 12.0513 1 12.4471C1 12.8429 1.33579 13.1638 1.75 13.1638Z",
    stroke: "#ABA7AF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreedotver);
export default __webpack_public_path__ + "static/media/threedotver.305893dc5bd88e347f87142527e1b9d8.svg";
export { ForwardRef as ReactComponent };